import React from "react";
import {
    NoPermissionContainer,
    NoPermissionTitle,
    NoPermissionMessage,
    NoPermissionButton,
} from "./NoPermission.styles";

// Language Context
import { useLanguage } from "../../core/translations/LanguageContext";

// Translations
import { NoPermissionTranslations } from "./translations/types";
import { enTranslations } from "./translations/en";
import { deTranslations } from "./translations/de";
import { SupportedLanguage } from "../../core/translations/supportedLanguages";

const TRANSLATIONS: Record<SupportedLanguage, NoPermissionTranslations> = {
    en: enTranslations,
    de: deTranslations,
};

export interface NoPermissionProps {
    // Omitted where the surrounding page already offers a way out (the landing
    // page keeps its header), rendering the panel as a plain message.
    onBack?: () => void;
}

/**
 * Tells a signed-in user who holds no admin role that the admin panel is not
 * for them. Shown at login instead of a role picker, and on the landing page
 * instead of the blank space a non-admin session used to land on.
 */
const NoPermission: React.FC<NoPermissionProps> = ({ onBack }) => {
    const { language } = useLanguage();
    //@ts-ignore
    const translations = TRANSLATIONS[language];

    return (
        <NoPermissionContainer>
            <NoPermissionTitle>{translations.title}</NoPermissionTitle>
            <NoPermissionMessage>{translations.message}</NoPermissionMessage>
            {onBack && (
                <NoPermissionButton type="button" onClick={onBack}>
                    {translations.back}
                </NoPermissionButton>
            )}
        </NoPermissionContainer>
    );
};

export default NoPermission;
